import React from 'react';
import DefaultPaymentHeader from './default_header';

// ModuleId = 8、CompanyId = 3 的付款页品牌资料统一在此维护。
// 未配置的字段会自动沿用当前 Company 资料，避免特殊品牌资料不完整时出现空白。
const branding = {
  Logo: '/assets/images/company-logo/3_8.png',
  Name: 'Plannable Town Planning  ',
  Website: 'plannabletp.com.au',
  Phone: '07 3303 2703',
  ContactEmail: 'info@plannabletp.com.au',
  Abn: '92 616 054 141',
};

const Module8Company3Header = ({ company }) => (
  <DefaultPaymentHeader company={company} branding={branding} />
);

export default Module8Company3Header;
